import type { AuthUser } from 'aws-amplify/auth'
import type { ReactNode } from 'react'

export interface AuthProviderProps {
  children: ReactNode
}

export enum AuthStatus {
  Configuring = 'configuring',
  Unauthenticated = 'unauthenticated',
  Authenticated = 'authenticated'
}

export interface AuthContextType {
  user: AuthUser | undefined
  signOut: (() => void) | undefined
}
